// extracted by mini-css-extract-plugin
module.exports = {"WhitepaperTitle":"Index_WhitepaperTitle__vRc8r","WhitepaperModal":"Index_WhitepaperModal__qQQhD","Select":"Index_Select__9X2HR"};